import { handleResponseOld, makePost } from './helpers';

/**
 * @category Item API
 * @see fetchItemDetailsByIds
 */
type FetchItemDetailsByIdsParams = {
    authToken?: string;
    deployment: string;
    itemIds: number[];
};
/**
 * Fetches Item details by given itemIds via Post to Item API service
 * @function fetchItemDetailsByIds
 * @category Item API
 * @param {FetchItemDetailsByIdsParams}
 * @see https://item-api-DEPLOYMENT.liveauctioneers.com/spa/small/item-detail
 * @see https://github.com/LIVEauctioneers/item-api/blob/master/src/inventory/routes/post-item-detail.ts
 */
const fetchItemDetailsByIds = ({ authToken, deployment, itemIds }: FetchItemDetailsByIdsParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({ authToken, deployment, path: '<ITEM-API>spa/small/item-detail' });
        request.send({ itemIds });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

export default {
    fetchItemDetailsByIds,
};
